import { FC } from 'react';

import VerifiedIcon from '@mui/icons-material/Verified';

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/TailwindComponents/base/Tooltip/Tooltip';
import { cn } from '@/components/TailwindComponents/lib/utils';

export interface VerifiedBadgeProps {
  tooltip?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

/**
 * VerifiedBadge component
 * Displays a verified icon with tooltip indicating the field was populated from state ID scan
 */
export const VerifiedBadge: FC<VerifiedBadgeProps> = ({
  tooltip = 'Verified by state ID',
  size = 'md',
  className,
}) => {
  const sizeMap = {
    sm: 18,
    md: 22,
    lg: 26,
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className={cn(
              'inline-flex items-center justify-center ml-1 cursor-help',
              className,
            )}
          >
            <VerifiedIcon sx={{ color: '#3b82f6', fontSize: sizeMap[size] }} />
          </span>
        </TooltipTrigger>
        <TooltipContent
          side="top"
          className="bg-gray-900 text-white border-gray-900"
        >
          <p>{tooltip}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default VerifiedBadge;
